import styled from "styled-components";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: inherit;
  height: inherit;
  align-content: center;
  justify-content: center;
`;

export default AppContainer;